var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton-cell",style:({ width: _vm.width || '100%', height: _vm.height || '1rem' })})}
var staticRenderFns = []

export { render, staticRenderFns }